import React from "react";
import PropTypes from "prop-types";
import Link from "components/elements/link";

const CTASignUp = ({ type }) => (
  <section className="cta-banner cta-sign-up">
    <div className="container">
      <div className="cta-banner__content">
        <p className="section-heading">
          {type === "seller" && (
            <span>
              Sounds good? <strong>Become a seller</strong> - it's very simple.
            </span>
          )}
          {type === "buyer" && (
            <span>
              Sounds good? <strong>Become a buyer</strong> - it's very simple.
            </span>
          )}
        </p>

        <Link className="btn btn-secondary btn-lg" to={`register/${type}`}>
          {type === "seller" && <span>Create a seller account</span>}
          {type === "buyer" && <span>Create a buyer account</span>}
        </Link>
      </div>
    </div>
  </section>
);

export default CTASignUp;

CTASignUp.propTypes = {
  type: PropTypes.oneOf(["seller", "buyer"]).isRequired,
};
